import React from 'react'
import styled from 'styled-components'

const Placeholder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.palette.neutral.default.six};
`

interface Props {
  icon: React.ReactNode
}

export default function ItemImagePlaceholder(props: Props) {
  return <Placeholder>{props.icon}</Placeholder>
}
